import { useSeo } from "../lib/seo";
import { useState } from "react";
import { useData } from "../context/DataContext";
import { PageShell } from "../components/PageShell";
import { DecisionRow, EmptyState, GuestBanner } from "../components/DecisionList";

export default function HistoryPage() {
  useSeo({ title: "History | DITHER", description: "Your past DITHER decisions.", noindex: true });
  const { history, signedIn, clearHistory, isFavourite, toggleFavourite } = useData();
  const [confirm, setConfirm] = useState(false);
  return (
    <PageShell title="History" subtitle="Everything DITHER has decided for you." testId="history-page">
      {!signedIn && <GuestBanner />}
      {history.length ? (
        <>
          <div className="mb-3 flex justify-end">
            <button className={`chip ${confirm ? "bg-pop-pink text-white" : ""}`} data-testid="history-clear-button"
              onClick={() => (confirm ? (clearHistory(), setConfirm(false)) : setConfirm(true))}>
              {confirm ? "Tap again to clear" : "Clear history"}
            </button>
          </div>
          <ul className="space-y-3" data-testid="history-list">
            {history.map((h, i) => <DecisionRow key={h.id} item={h} index={i} fav={isFavourite(h)} onFav={() => toggleFavourite(h)} />)}
          </ul>
        </>
      ) : (
        <EmptyState title="Nothing yet" body="Make a decision and it'll show up here." />
      )}
    </PageShell>
  );
}
